import {Component, OnDestroy, OnInit} from '@angular/core';
import {RulesService} from '../rules.service';
import {ActivatedRoute, Router} from '@angular/router';
import {Subscription} from 'rxjs/Subscription';

@Component({
  selector: 'app-rules-list',
  templateUrl: './rules-list.component.html',
  styleUrls: ['./rules-list.component.scss']
})
export class RulesListComponent implements OnInit, OnDestroy {
  ruleList = [];
  isLoading: boolean;
  sub: Subscription;
  // pagination details
  currentPage = 1;
  totalPage;
  maxSize = 3;
  pageSize: number;
  constructor(private ruleService: RulesService,
              private route: ActivatedRoute,
              private router: Router) { }
  ngOnInit() {
    this.sub = this.route.params.subscribe(params => {
        this.currentPage = params.page ? params.page : 1;
        this.pageSize = params.pageSize ? params.pageSize : 10;
        this.getRuleList(this.currentPage, this.pageSize);
      });
  }

  onRuleDelete() {
    if (this.currentPage * this.pageSize - this.totalPage === 1) {
      this.currentPage--;
    }
    if (this.currentPage > 0) {
      this.getRuleList(this.currentPage, this.pageSize);
    } else {
      this.router.navigate(['/rules']);
    }
  }

  getRuleList(page: number, pageSize: number) {
    this.isLoading = true;
    this.ruleService.getRuleList(page, pageSize)
      .subscribe(res => {this.ruleList = res.items;  this.isLoading = false; this.totalPage = res.count; },
          err => { this.isLoading = false; });
  }
  onPageChange(event) {
    this.router.navigate(['/rules/list', {page: event.page, pageSize: this.pageSize}]);
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./src/app/rules/rules-list/rules-list.component.ts